import { render, staticRenderFns } from "./publicConsultation.vue?vue&type=template&id=01b0c05f&scoped=true"
import script from "./publicConsultation.vue?vue&type=script&lang=js"
export * from "./publicConsultation.vue?vue&type=script&lang=js"
import style0 from "./publicConsultation.vue?vue&type=style&index=0&id=01b0c05f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0c05f",
  null
  
)

export default component.exports